import { render, staticRenderFns } from "./SoftHome.vue?vue&type=template&id=14a9c3ef&scoped=true&"
import script from "./SoftHome.vue?vue&type=script&lang=js&"
export * from "./SoftHome.vue?vue&type=script&lang=js&"
import style0 from "./SoftHome.vue?vue&type=style&index=0&id=14a9c3ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a9c3ef",
  null
  
)

export default component.exports